// extracted by mini-css-extract-plugin
module.exports = {"dimmer":"MultiProductDateForm_dimmer__9OeB_"};